export const selectTransferVoucherNo = (s) => s.transferEntry.voucherNo;
export const selectTransferItems = (s) => s.transferEntry.itemsList;
export const selectFooterValues = (s) => s.transferEntry.footerValues;